<template>
  <label class="ux-field-title" v-if="showLabel"
    >{{ label }}
    <span class="ux-required-marker" v-if="required">*</span></label
  >
  <div class="ux-field-description" v-if="showDescription">
    {{ description }}
  </div>
  <div v-if="multiValue">
    <flex-row
      class="ux-signature-row"
      gap
      :key="index"
      v-for="(entry, index) in model"
    >
      <flex-cell>
        <signature
          class="ux-field-focus ux-signature-input ux-signature-input-multiple"
          @focus="touch"
          ref="input"
          v-model="model[index]"
        />
      </flex-cell>
      <flex-cell shrink vcenter>
        <ux-button tag="a" icon v-if="canRemoveValue" @click="remove(entry)">
          <ux-icon icon="fa-times" />
        </ux-button>
      </flex-cell>
    </flex-row>
    <ux-button v-if="canAddValue" @click="add()">{{ addLabel }}</ux-button>
  </div>
  <template v-else>
    <signature
      type="color"
      class="ux-field-focus ux-signature-input ux-signature-input-single"
      @focus="touch"
      v-model="model"
    />
  </template>
</template>
<script>
import InputMixin from "./input-mixin";
import signature from "./signature.vue";
//////////////////////////

export default {
  components: {
    signature,
  },
  props: {
    modelValue: {
      type: String,
    },
  },
  mixins: [InputMixin],
  methods: {
    getNewDefaultEntry() {
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-signature-row {
  margin-bottom: 0.5em;
}
</style>
